import { Button } from "../../../components/ui/button";
import { Badge } from "../../../components/ui/badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faPhone,
  faCalendarPlus,
  faCircle,
  faClock,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/ui/modal";

const statusStyles = {
  Active: "bg-green-600 text-white border-green-200",
  Inactive: "bg-red-500 text-white border-red-200",
};

const ViewSellerModal = ({ seller, onClose }) => {
  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Seller Details"
      footer={
        <div className="flex justify-end">
          <Button
            variant="outline"
            onClick={onClose}
            className="px-6 border-orange-600 border-2 hover:text-white hover:bg-orange-500 hover:border-none transition-colors duration-300"
          >
            Close
          </Button>
        </div>
      }
    >
      {seller && (
        <div className="flex flex-col gap-4">
          {/* Info Banner */}
          <div className="flex items-center gap-3 p-3 bg-gradient-to-r from-blue-50 to-white rounded-lg border border-blue-100">
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
              <FontAwesomeIcon
                icon={faUser}
                className="text-blue-800 h-4 w-4"
              />
            </div>
            <div>
              <p className="text-sm text-gray-600 font-medium">
                Seller information
              </p>
              <p className="text-xs font-semibold text-gray-900">
                {seller.seller_name}
              </p>
            </div>
          </div>

          {/* Details Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
              <p className="text-xs text-gray-600 font-medium uppercase tracking-wider flex items-center gap-1.5">
                <FontAwesomeIcon
                  icon={faUser}
                  className="text-blue-600 h-3 w-3"
                />
                Seller Name
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-1">
                {seller.seller_name}
              </p>
            </div>

            <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
              <p className="text-xs text-gray-600 font-medium uppercase tracking-wider flex items-center gap-1.5">
                <FontAwesomeIcon
                  icon={faPhone}
                  className="text-blue-600 h-3 w-3"
                />
                Phone Number
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-1">
                {seller.phone}
              </p>
            </div>

            <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
              <p className="text-xs text-gray-600 font-medium uppercase tracking-wider flex items-center gap-1.5">
                <FontAwesomeIcon
                  icon={faCalendarPlus}
                  className="text-blue-600 h-3 w-3"
                />
                Added Date
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-1">
                {seller.added_date}
              </p>
            </div>

            <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
              <p className="text-xs text-gray-600 font-medium uppercase tracking-wider flex items-center gap-1.5">
                <FontAwesomeIcon
                  icon={faCircle}
                  className="text-blue-600 h-3 w-3"
                />
                Status
              </p>
              <div className="mt-1">
                <Badge
                  variant="outline"
                  className={`${statusStyles[seller.status]} border font-normal px-3 py-1 rounded-full text-xs flex items-center gap-1.5`}
                >
                  <span
                    className={`inline-block w-1.5 h-1.5 rounded-full ${seller.status === "Active" ? "bg-green-500" : "bg-red-500"}`}
                  />
                  {seller.status}
                </Badge>
              </div>
            </div>

            {/* Created At - NEW */}
            <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
              <p className="text-xs text-gray-600 font-medium uppercase tracking-wider flex items-center gap-1.5">
                <FontAwesomeIcon
                  icon={faClock}
                  className="text-green-600 h-3 w-3"
                />
                Created At
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-1">
                {formatDate(
                  seller.created_at || seller.createdAt || seller.created,
                )}
              </p>
            </div>

            {/* Updated At - NEW */}
            <div className="bg-gray-50 p-3 rounded-lg border border-gray-100">
              <p className="text-xs text-gray-600 font-medium uppercase tracking-wider flex items-center gap-1.5">
                <FontAwesomeIcon
                  icon={faPenToSquare}
                  className="text-orange-600 h-3 w-3"
                />
                Updated At
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-1">
                {formatDate(
                  seller.updated_at || seller.updatedAt || seller.updated,
                )}
              </p>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ViewSellerModal;
